// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import Avatar from './data'

export default function AvatarFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/Avatar">
      <Avatar {...props}>
        {children}
      </Avatar>
    </Flow>
  )
}
